import React from "react";
import { fmtCurrency, fmtPct, signColor } from "@/lib/format";

const Cell = ({ label, value, sub, color, testid }) => (
  <div className="card flex-1 min-w-0" data-testid={testid}>
    <p className="label-xs mb-3">{label}</p>
    <p className="font-serif text-4xl xl:text-5xl leading-none font-light" style={{ color: color || "var(--text-primary)" }}>
      {value}
    </p>
    {sub && (
      <p className="text-xs mt-3" style={{ color: sub.color || "var(--text-secondary)" }}>
        {sub.text}
      </p>
    )}
  </div>
);

export default function SummaryCards({ summary }) {
  const monthly = summary?.total_monthly_income || 0;
  const annual = summary?.total_annual_income || 0;
  const totalValue = summary?.total_value || 0;
  const gainLoss = summary?.gain_loss || 0;
  const gainPct = summary?.gain_loss_pct || 0;
  const portYield = summary?.portfolio_yield || 0;
  const yoc = summary?.yield_on_cost || 0;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
      <Cell
        testid="summary-monthly-income"
        label="Projected / month"
        value={fmtCurrency(monthly)}
        color="var(--gain)"
        sub={{ text: `≈ ${fmtCurrency(annual)} / year` }}
      />
      <Cell
        testid="summary-total-value"
        label="Portfolio value"
        value={fmtCurrency(totalValue)}
        sub={{
          text: `${gainLoss >= 0 ? "+" : ""}${fmtCurrency(gainLoss)} (${gainPct >= 0 ? "+" : ""}${fmtPct(gainPct)})`,
          color: signColor(gainLoss),
        }}
      />
      <Cell
        testid="summary-portfolio-yield"
        label="Portfolio yield"
        value={fmtPct(portYield)}
        sub={{ text: `YoC ${fmtPct(yoc)}`, color: "var(--text-secondary)" }}
      />
      <Cell
        testid="summary-holdings-count"
        label="Positions"
        value={String(summary?.holding_count || 0).padStart(2, "0")}
        sub={{ text: "active tickers" }}
      />
    </div>
  );
}
